module.exports = __webpack_public_path__ + "img/activate.33eb69c2.svg";